import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import allPlugins from "../../utils/suneditorPlugins";
import apiClient, { getEditorUploadConfig } from '../../services/apiClient';
import "./custom.css";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";

function SendToCustomerInfoModal({
  showModal,
  closeModal,
  type,
  id,
  title,
  contentpage,
  details,
  payment,
  taxperstate,
  taxstate,
  discountperState,
  discountState,
  invoicenumber,
  purchageorder,
  usersignature,
}) {
  const [content, setContent] = useState("");
  const [subject, setSubject] = useState("");
  const [email, setEmail] = useState("");
  const editorRef = useRef(null);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { eventID, documentId } = useParams();

  const [EventData, setEventData] = useState({});
  const [emailtemplate, setEmailtemplate] = useState([]);
  const navigate = useNavigate();

  const [isProcessing, setIsProcessing] = useState(false);

  // Function to handle content changes from the editor
  const handleEditorChange = (newContent) => {
    setContent(newContent);
  };

  const handleEmailChange = (e) => {
    const updatedEmail = e.target.value;
    setEventData((prevState) => ({
      ...prevState, // Keep the other properties of EventData intact
      cl_email: updatedEmail, // Update only the cl_email field
    }));
  };

  // Function to update editor content when state changes
  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.editor.setContents(content);
    }
  }, [content]);

  // Function to toggle placeholder visibility
  const handlePlaceholder = () => {
    if (editorRef.current) {
      // alert("dhirendra");
      const editor = editorRef.current.editor;
      alert(editor.getContents());
      const placeholder = document.querySelector(".editor-placeholder");
      if (editor.getContents() === "") {
        placeholder.classList.remove("hidden");
      } else {
        placeholder.classList.add("hidden");
      }
    }
  };

  // Update placeholder visibility on content change
  useEffect(() => {
    handlePlaceholder();
  }, [content]);

  // Function to initialize modal
  const initializeModal = () => {
    if (window.bootstrap && modalRef.current) {
      const modalInstance = new window.bootstrap.Modal(modalRef.current);
      return modalInstance;
    }
    return null;
  };

  const modalRef = useRef(null);
  const [formData, setFormData] = useState({
    mainLogo: "",
    secondaryLogo: "",
    defaultHeaderImage: "",
  });

  // Options for the SunEditor instance
  const editorOptions = {
    height: 200,
    plugins: allPlugins,
    ...getEditorUploadConfig(),
    buttonList: [
      [
        "codeView",
        "paragraphStyle",
        "bold",
        "underline",
        "italic",
        "strike",
        "table",
        "link",
        "horizontalRule",
        "list",
        "align",
        "hiliteColor",
        "image",
        "video",
      ],
    ],
    imageRotation: false,
    fontSize: [12, 14, 16, 18, 20],
    toolbarPosition: "bottom",
    colorList: [
      [
        "#828282",
        "#FF5400",
        "#676464",
        "#F1F2F4",
        "#FF9B00",
        "#F00",
        "#fa6e30",
        "#000",
        "rgba(255, 153, 0, 0.1)",
        "#FF6600",
        "#0099FF",
        "#74CC6D",
        "#FF9900",
        "#CCCCCC",
      ],
    ],
  };

  const [phone, setPhone] = useState();
  const [companyemail, setCompanyemail] = useState();
  const [fname, setFname] = useState();
  const [lname, setLname] = useState();
  const [companyname, setCompanyname] = useState();

  const [selectedTemplate, setSelectedTemplate] = useState("");

  // Handle when the user selects a template
const handleChange = (e) => {
  const selectedValue = e.target.value;

  const selectedTemplateObj = emailtemplate.find(
    (template) => template.title === selectedValue
  );

  if (selectedTemplateObj) {
    const replacedContent = selectedTemplateObj.content
      .replace(/{Event_Name}/g, EventData?.name || "Event Name")
      .replace(/{First_Client_First_Name}/g, EventData?.cl_firstname || "")
      .replace(/{First_Client_Last_Name}/g, EventData?.cl_lastname || "")
      .replace(/{First_Client_Email}/g, EventData?.cl_email || "")
      .replace(
        /{Event_Type}/g,
        EventData?.get_event_category?.name || "Event Type"
      );

    setSelectedTemplate(selectedTemplateObj.title); // title stays selected
    setSubject(selectedTemplateObj.title);
    setContent(replacedContent);
  }
};


  useEffect(() => {
    const modalInstance = initializeModal();
    if (modalInstance) {
      if (showModal) {
        modalInstance.show();
      } else {
        modalInstance.hide();
      }
    }
  }, [showModal]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await apiClient.get(
          `/userdetaila/${
            JSON.parse(localStorage.getItem("user")).user.id
          }`
        );

        setFormData({
          mainLogo: response.data.usersdetails[0].Main_Logo
            ? process.env.REACT_APP_BACKEND_URL +
              response.data.usersdetails[0].Main_Logo
            : null,
          secondaryLogo: response.data.usersdetails[0].Secondary_Logo
            ? process.env.REACT_APP_BACKEND_URL +
              response.data.usersdetails[0].Secondary_Logo
            : null,
          defaultHeaderImage: response.data.usersdetails[0].Header_Images
            ? process.env.REACT_APP_BACKEND_URL +
              response.data.usersdetails[0].Header_Images
            : null,
        });

        setPhone(response.data.usersdetails[0].Phone_Number);
        setCompanyemail(response.data.usersdetails[0].Company_Email);

        setFname(response.data.usersdetails[0].first_name);
        setLname(response.data.usersdetails[0].last_name);
        setCompanyname(response.data.usersdetails[0].companyname);

        if (response.data.usersdetails[0].Secondary_Logo) {
          //setContent(`<p className="smart_text"><img src="${response.data.usersdetails[0].Secondary_Logo}" alt='Main Logo Preview' style='width: 200px; height:auto;'/></p>`);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();

    const fetchEventDetails = async () => {
      try {
        const response = await apiClient.get(`/event/${eventID}`);
        if (response.data.success === true) {
          setEventData(response.data.events);
          // setCompanyemail(response.data.usersdetails[0].email);
        }
      } catch (error) {
        console.error("Error fetching event details:", error);
      }
    };

    fetchEventDetails();

    const fetchemailtemplates = async () => {
      try {
        const response = await apiClient.get(
          `/getemail-templates/${
            JSON.parse(localStorage.getItem("user")).user.id
          }`
        );
        const data = response.data;
        //setEmailtemplate(response.data);
        setEmailtemplate(Array.isArray(data) ? data : [data]);
      } catch (error) {
        console.error("Error fetching event details:", error);
      }
    };

    fetchemailtemplates();
  }, []);

  const sendtocustomer = async () => {
    if (isProcessing) return; // Prevent multiple clicks

    setIsProcessing(true);

    try {
      const response = await apiClient.post(
        `/sendquote`,
        {
          user_id: JSON.parse(localStorage.getItem("user")).user.id,
          username: fname,
          user_email: EventData.cl_email,
          customername: EventData.cl_firstname + " " + EventData.cl_lastname,
          details: content,
          subject: subject,
          email_to: EventData.cl_email,
          logo: formData.secondaryLogo,
          type: type,
          id: id,
          eventID: eventID,
          title: title,
          pages: JSON.stringify(details),
          contnet: JSON.stringify(contentpage),
          payment: JSON.stringify(payment),
          taxper: taxperstate,
          tax: taxstate,
          discountper: discountperState,
          discount: discountState,
          code: type === 'Invoice' ? null : invoicenumber,
          purchorder: purchageorder,
          usersignature: usersignature,
        }
      );

      if (response.data.success) {
        // alert('Email send Sucessfully');
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Email Sent Successfully!",
          confirmButtonText: "OK",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showCancelButton: false,
        }).then((result) => {
          if (result.isConfirmed) {
            document.getElementById("closemodel").click();
            navigate("/events");
          }
        });
      }

    } catch (error) {
      console.error("Error fetching contracts:", error);
    }
  };

  return (
    <div
      className="modal fade"
      id="exampleModal2"
      ref={modalRef}
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
        style={{ minHeight: "700px" }}
      >
        <div className="modal-content">
          {/* Modal header */}
          <div className="modal-header bg-primary">
            <h5 className="modal-title text-white w-100 text-center">
              Send To Customer
            </h5>
            <button
              type="button"
              className="close"
              data-bs-dismiss="modal"
              id="closemodel"
            >
              <span aria-hidden="true" className="modal_button">
                <i className="fas fa-close"></i>
              </span>
              <span className="sr-only">Close</span>
            </button>
          </div>
          <div className="modal-body  px-4" style={{ background: "#f1f5f9" }}>
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="col-md-12 d-flex">
                  <label htmlFor="eventName" className="labelcls">
                    EMAIL TO
                  </label>
                  <input
                    name="eventName"
                    id="eventName"
                    type="text"
                    className="minHeightOverride "
                    placeholder="participants"
                    value={EventData.cl_email}
                    required
                    onChange={handleEmailChange}
                  />
                </div>
              </div>
            </div>
            <div className="row"> &nbsp;</div>
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="col-md-12 d-flex">
                  <label htmlFor="eventName" className="labelcls">
                    SUBJECT
                  </label>
                  <input
                    name="eventName"
                    id="eventName"
                    type="text"
                    className="minHeightOverride"
                    placeholder="what is topic?"
                    value={subject}
                    required
                    onChange={(e) => setSubject(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row"> &nbsp;</div>
            <div className="row event">
              <p className="smart_text">
                <img
                  src={formData.secondaryLogo}
                  alt="Main Logo Preview"
                  style={{ width: "100px", height: "auto" }}
                />
              </p>
              <SunEditor
                setOptions={editorOptions}
                ref={editorRef}
                setContents={content}
                onChange={handleEditorChange}
              />
              {/* <div className={`editor-placeholder ${content!="" ? 'hidden' : ''}`}>
              {`type {to add a smart field` }
              </div> */}
            </div>
            <div className="row"> &nbsp;</div>
            <div className="row">
              <div className="col-lg-12 col-md-12 d-flex">
                <div className="col-md-8 ">
                  <label htmlFor="eventName" className="labelcls">
                    Select A Created Template
                  </label>

                  <select
                    value={selectedTemplate}
                    onChange={handleChange}
                    style={{ border: "1px solid azure", borderRadius: "4px" }}
                  >
                    <option value="">Select a template</option>
                    {Array.isArray(emailtemplate) &&
                      emailtemplate.map((template) => (
                        <option key={template.id} value={template.title}>
                          {template.title}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <button
                    type="button"
                    className="but-primary"
                    onClick={sendtocustomer}
                    disabled={isProcessing}
                  >
                    {isProcessing ? "Processing..." : "Send"}
                  </button>
                </div>
              </div>
            </div>

            <div className="row"> &nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SendToCustomerInfoModal;
